module.exports = __webpack_public_path__ + "static/media/sd.e80acbd2.svg";